import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../hooks/useScollToTop";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";
import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";

import { useCalendarEvents } from "./hooks/useCalendarEvents";

import CalendarEventsHero from "./components/CalendarEventsHero";
import CalendarEventsToolbar from "./components/CalendarEventsToolbar";
import CalendarEventCard from "./components/CalendarEventCard";
import CalendarEventSkeleton from "./components/CalendarEventSkeleton";
import CalendarEventsEmptyState from "./components/CalendarEventsEmptyState";
import { FaCalendarAlt } from "react-icons/fa";

export default function CalendarEvents() {
  useScrollToTop();

  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const {
    loading,
    error,

    events,
    filteredEvents,
    visibleEvents,

    favoriteEvents,
    userId,

    ui,
    debouncedSearch,
    setDebouncedSearch,
    updateUi,
    resetFilters,
    loadMore,
    refresh,

    stats,

    typeOptions,
    categoryOptions,
    levelOptions,

    handleFavoriteChange,
  } = useCalendarEvents();

  return (
    <section className="min-h-screen bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-white">
      <ScrollIndicator />

      <div className="pt-[96px] sm:pt-[120px] lg:pt-[160px]" aria-hidden />

      <main className="mx-auto w-full max-w-7xl px-3 pb-24 sm:px-6 lg:px-8">
        <HeaderTitle
          role="Utilisateur"
          title="Calendrier des événements"
          subtitle="Participe aux événements proposés par le club."
          icon={FaCalendarAlt}
          align="left"
          className="mb-4"
        />

        <div className="mb-5 sm:mb-7">
          <DashboardNavigation role={userRole} />
        </div>

        <CalendarEventsHero
          stats={stats}
          loading={loading}
          onRefresh={refresh}
        />

        <section className="mt-4 overflow-hidden rounded-[2rem] border border-white/70 bg-white/85 shadow-xl shadow-slate-200/70 backdrop-blur dark:border-slate-800/80 dark:bg-slate-900/70 dark:shadow-black/20 sm:mt-6">
          <div className="border-b border-slate-200/70 bg-white/70 px-3 py-3 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
            <CalendarEventsToolbar
              ui={ui}
              updateUi={updateUi}
              debouncedSearch={debouncedSearch}
              setDebouncedSearch={setDebouncedSearch}
              typeOptions={typeOptions}
              categoryOptions={categoryOptions}
              levelOptions={levelOptions}
              onReset={resetFilters}
              loading={loading}
              onRefresh={refresh}
              totalCount={events.length}
              filteredCount={filteredEvents.length}
            />
          </div>

          <div className="p-3 sm:p-5 lg:p-6">
            {loading ? (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                {Array.from({ length: 6 }).map((_, index) => (
                  <CalendarEventSkeleton key={index} />
                ))}
              </div>
            ) : error ? (
              <div className="rounded-[1.75rem] border border-red-200 bg-red-50 px-5 py-8 text-center text-sm font-semibold text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
                {error}
              </div>
            ) : filteredEvents.length === 0 ? (
              <CalendarEventsEmptyState
                favoriteOnly={ui.favoriteOnly}
                onReset={resetFilters}
              />
            ) : (
              <>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                  {visibleEvents.map((event) => (
                    <CalendarEventCard
                      key={event.id}
                      event={event}
                      userId={userId}
                      isFavorite={favoriteEvents.includes(event.id)}
                      onFavoriteChange={handleFavoriteChange}
                    />
                  ))}
                </div>

                {visibleEvents.length < filteredEvents.length && (
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={loadMore}
                      className="inline-flex min-h-12 items-center justify-center rounded-2xl bg-[#013E8E] px-5 text-sm font-bold text-white shadow-lg shadow-blue-900/20 transition hover:-translate-y-0.5 hover:bg-indigo-800 hover:shadow-xl"
                    >
                      Charger plus
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </main>

      <ToastContainer />
    </section>
  );
}
